import React from "react";
import { ReferenceInput, SelectInput } from "react-admin";

const RangesInput = (props) => (
  <ReferenceInput {...props} reference="stats-declinated/ranges">
    <SelectInput optionText="name" />
  </ReferenceInput>
);
export default RangesInput;
